import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { AppShell } from '../modules/app-shell/ui/AppShell';
import { useRedirectWhenSignedOut } from '../modules/auth/ui/use-redirect-on-sign-out';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: () => {
    if (!getCurrentSession()) {
      throw redirect({ to: '/login' });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  // beforeLoad only enforces "session required" on route load, not
  // reactively. When the session is cleared in place — manual sign-out, an
  // idle-timeout expiration, or a failed refresh — nothing would otherwise
  // navigate and the user would sit on an authenticated URL with no
  // session. See use-redirect-on-sign-out.ts.
  useRedirectWhenSignedOut();

  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
